import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Post } from '../shared/models/posts/post';
import { PostsService } from '../shared/services/posts.service';

@Component({
  selector: 'app-task',
  templateUrl: './task.component.html',
  styleUrls: ['./task.component.scss']
})
export class TaskComponent implements OnInit {  
  public post: Post = null;

  constructor(
    private _activatedRoute: ActivatedRoute,
    private _postsService: PostsService
  ) { }

  ngOnInit(): void {
    this._activatedRoute.params.subscribe(
      params => {    
        this.post = null;
        this._getPost(params['id']);        
      }
    ); 
  }

  private _getPost(id: number) {
    this._postsService.getPost(id).subscribe(
      response => {
        this.post = new Post(response);
      },
      error => {
        console.log(error);
        this.post = new Post({});
      }
    )
  }

}
